import { OrderAttributes } from '@albatrosdeveloper/ave-models-package';
import { DecimalPipe } from '@angular/common';
import omit from 'lodash-es/omit';
import { SalesInvoiceListExcelExportProcessor } from './sales-invoice-list-excel';

export class SalesInvoiceListJsonExportProcessor extends SalesInvoiceListExcelExportProcessor {
  constructor(decimalPipe: DecimalPipe) {
    super(decimalPipe);
  }

  protected override transformForMainSection(item: OrderAttributes) {
    return {
      ...super.transformForMainSection(item),
      details: super.transformForDetailsSection(item).map((data) => omit(data, 'serial', 'trip')),
    }
  }

  override onAddData(item: OrderAttributes) {
    this.addToSection('orders', this.transformForMainSection(item));
  }
}
